import React, { useEffect, useState, useMemo, useReducer } from 'react'
import { debounce } from 'leva/plugin'
import { PreviewSvg } from '../styles/StyledBezier'
import type { BezierProps } from '../types/bezier-types'
import { bezierPreviewAnimationDurationMultiplier, bezierPreviewAnimationDensity } from '../assets/constants'

const DebouncedBezierPreview = React.memo(({ value, readKeyframePairDuration }: Pick<BezierProps, 'value'>  & { readKeyframePairDuration: 'readKeyframePairDuration' }) => {
  // use to forceUpdate on click
  const [, forceUpdate] = useReducer((x) => x + 1, 0)
  let baseMs = parseInt(readKeyframePairDuration) * bezierPreviewAnimationDurationMultiplier
  const plotPoints = Array(bezierPreviewAnimationDensity + 1)
    .fill(0)
    .map((_, i) => 5 + value.evaluate(i / bezierPreviewAnimationDensity) * 90)

  return (
    <PreviewSvg onClick={forceUpdate}>
      {plotPoints.map((p, i) => (
        <circle key={i + Date.now()} r={3} cx={`${p}%`} style={{ animationDelay: `${i * baseMs}ms` }} />
      ))}
      <circle
        key={Date.now() - 1}
        r={3}
        style={{
          animationTimingFunction: `cubic-bezier(${value.join(',')})`,
          animationDuration: `${plotPoints.length * baseMs}ms`,
        }}
      />
    </PreviewSvg>
  )
})

export function BezierPreview({ value, readKeyframePairDuration }: Pick<BezierProps, 'value'> & { readKeyframePairDuration: number }) {
  const [debouncedValue, set] = useState(value)
  const [debouncedDuration, setDuration] = useState(readKeyframePairDuration)
  const debounceValue = useMemo(() => debounce((v: typeof value, readKeyframePairDuration: number) => set(v), 250), [])
  //@ts-ignore
  const debounceDuration = useMemo(() => debounce((d) => setDuration(d), 250), [])  
  useEffect(() => void debounceValue(value, readKeyframePairDuration), [value, readKeyframePairDuration, debounceValue])
  useEffect(() => void debounceDuration(readKeyframePairDuration), [readKeyframePairDuration, debounceDuration])
  // @ts-ignore
  return <DebouncedBezierPreview value={debouncedValue} readKeyframePairDuration={debouncedDuration}/>
}